import http from "./http/http_protected_stream";

const getReport = (summary_id) => http.get("/property/pdf/" + summary_id);
const processReport = (body) => http.post("/property/pdf", body);
const getMultipleReports = (body) => http.post("/property/multi_pdf", body)

export default {
    getReport,
    processReport,
    getMultipleReports
}